import { BrowserRouter, Route, Routes } from "react-router";
import { NotFoundPage } from "@/domains/general";
import { RequireAuth } from "@/v2/auth/requireAuth";
import { RequireRole } from "@/v2/auth/requireRole";
import { LoginPage } from "@/v2/auth/loginPage";
import { V2Layout } from "@/v2/layout/v2Layout";
import { DashboardPage } from "@/v2/dashboard/dashboardPage";
import { RequestListPage } from "@/v2/aanvragen/requestListPage";
import { RequestWizardPage } from "@/v2/aanvragen/requestWizardPage";
import { RequestDetailPage } from "@/v2/aanvragen/requestDetailPage";
import { DossierListPage } from "@/v2/dossiers/dossierListPage";
import { DossierDetailPage } from "@/v2/dossiers/dossierDetailPage";
import { AssetListPage } from "@/v2/assets/assetListPage";
import { NotificationsPage } from "@/v2/meldingen/notificationsPage";

export function V2Router(): React.JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <V2Layout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />

          <Route
            path="/aanvragen"
            element={
              <RequireRole roles={["requester", "manager"]}>
                <RequestListPage />
              </RequireRole>
            }
          />
          <Route
            path="/aanvragen/nieuw"
            element={
              <RequireRole roles={["requester", "manager"]}>
                <RequestWizardPage />
              </RequireRole>
            }
          />
          <Route
            path="/aanvragen/:id"
            element={
              <RequireRole roles={["requester", "manager"]}>
                <RequestDetailPage />
              </RequireRole>
            }
          />

          <Route
            path="/dossiers"
            element={
              <RequireRole roles={["manager"]}>
                <DossierListPage />
              </RequireRole>
            }
          />
          <Route
            path="/dossiers/:dossierId"
            element={
              <RequireRole roles={["manager"]}>
                <DossierDetailPage />
              </RequireRole>
            }
          />
          <Route
            path="/assets"
            element={
              <RequireRole roles={["manager"]}>
                <AssetListPage />
              </RequireRole>
            }
          />
          <Route
            path="/meldingen"
            element={
              <RequireRole roles={["manager"]}>
                <NotificationsPage />
              </RequireRole>
            }
          />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
